import CsCarousel from './CsCarousel.vue'
CsCarousel.install = function (Vue) {
  Vue.component(CsCarousel.name, CsCarousel)
}
export default CsCarousel



// WEBPACK FOOTER //
// ./src/components/carousel/index.js